export const environment = {
  production: false,
  apiUrl: 'https://back-vmdo-stage.kaeyros.org'
};
